/** @jsx h */
import { labels } from '../config';
import { useRef, useEffect } from 'preact/hooks';

const Pagination = ({ pagination, triggerLoadMore, pluginNamespace }) => {
  const paginationInputEl = useRef(null);

  useEffect(() => {
    if (paginationInputEl && paginationInputEl.current) {
      paginationInputEl.current.value = '';
    }
  }, []);

  function handleLoadMoreClick(event) {
    event && event.preventDefault();
    if (paginationInputEl && paginationInputEl.current) {
      paginationInputEl.current.value = pagination?.current + 1;
      triggerLoadMore();
    }
  }

  /* Only show load more button, if there is something to load */
  if (
    pagination &&
    (pagination.current === pagination.numberOfPages ||
      pagination.numberOfPages === 0)
  ) {
    return '';
  }

  return (
    <div className="search__load-more">
      <input
        type="text"
        name={`${pluginNamespace}[page]`}
        hidden
        readonly
        ref={paginationInputEl}
        aria-label={labels.pagination.loadMore}
      />
      <button
        className="btn btn--primary"
        type="button"
        onClick={handleLoadMoreClick}
      >
        <span>{labels.pagination.loadMore}</span>
        <svg
          className="svg-plus"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 80 80"
          aria-hidden="true"
        >
          <defs>
            <style>.cls-1{`fill-rule:evenodd;`}</style>
          </defs>
          <polygon
            fill="currentColor"
            className="cls-1"
            points="80 34 46 34 46 0 34 0 34 34 0 34 0 46 34 46 34 80 46 80 46 46 80 46 80 34"
          />
        </svg>
      </button>
    </div>
  );
};

export default Pagination;
